import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getFloatingType} from '../../../apis/floating/getFloatingTypes'

const useQueryFloatingType = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.floating.getFloatingType(),
        queryFn: async () => {
            const {data, pageInfo} = await getFloatingType()
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data: data?.data, pageInfo: data?.pageInfo, refetch}
}

export default useQueryFloatingType
